import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
  FLAG_GETTING_COMPANIES,
  GET_COMPANIES,
  CLEAR_COMPANIES,
  FLAG_COMPANY_ACTIVITY,
  GET_COMPANY,
  CLEAR_COMPANY,
  CLEAR_COMPANY_CUSTOMERS,
  GET_COMPANY_CUSTOMERS,
  FLAG_GETTING_COMPANY_CUSTOMERS,
  FLAG_GETTING_COMPANY_BUSINESSES,
  GET_COMPANY_BUSINESSES,
  CLEAR_COMPANY_BUSINESSES,
} from '../types';
import {
  COMPANY_BUSINESSES_ENDPOINT,
  COMPANY_CUSTOMERS_ENDPOINT,
  COMPANY_ENDPOINT,
} from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { COMPANY_PATH } from '../../config/paths';

const flagGettingCompanies = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_COMPANIES,
    payload: flag,
  });

const getCompanies = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingCompanies(true));

    const query = tableFilters;

    const url = `${COMPANY_ENDPOINT}?${QueryString.stringify(query)}`;

    const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

    await isErrorResponse(response, null, dispatch);

    const companies = await response.json();

    dispatch({
      type: GET_COMPANIES,
      payload: companies,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingCompanies(false));
  }
};

const clearCompanies = () => (dispatch) =>
  dispatch({
    type: CLEAR_COMPANIES,
  });

const flagCompanyActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_COMPANY_ACTIVITY,
    payload: flag,
  });

const postCompany =
  async ({ name, businessId, companyType }) =>
  async (dispatch) => {
    try {
      dispatch(flagCompanyActivity(true));

      const payload = { name, businessId, companyType };

      const url = COMPANY_ENDPOINT;

      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      await response.json();

      dispatch(push(COMPANY_PATH));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagCompanyActivity(false));
    }
  };

const getCompany =
  async ({ companyId }) =>
  async (dispatch) => {
    try {
      dispatch(flagCompanyActivity(true));

      const url = `${COMPANY_ENDPOINT}/${companyId}`;

      const response = await fetch(url, DEFAULT_GET_CONFIG);

      await isErrorResponse(response, null, dispatch);

      const company = await response.json();

      dispatch({
        type: GET_COMPANY,
        payload: company,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagCompanyActivity(false));
    }
  };

const clearCompany = () => (dispatch) =>
  dispatch({
    type: CLEAR_COMPANY,
  });

const putCompany =
  async (companyId, { name, businessId, companyType }) =>
  async (dispatch) => {
    try {
      dispatch(flagCompanyActivity(true));
      const payload = {
        name,
        businessId,
        companyType,
        id: companyId,
      };

      const url = `${COMPANY_ENDPOINT}/${companyId}`;

      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      const company = await response.json();

      dispatch(push(`${COMPANY_PATH}/${company.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagCompanyActivity(false));
    }
  };

const deleteCompany =
  async ({ companyId }) =>
  async (dispatch) => {
    try {
      dispatch(flagCompanyActivity(true));

      const url = `${COMPANY_ENDPOINT}/${companyId}`;

      const response = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });

      await isErrorResponse(response, null, dispatch);

      await response.json();

      dispatch(push(COMPANY_PATH));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagCompanyActivity(false));
    }
  };

const flagGettingCompanyCustomers = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_COMPANY_CUSTOMERS,
    payload: flag,
  });

const getCompanyCustomers = async (query) => async (dispatch) => {
  try {
    dispatch(flagGettingCompanyCustomers(true));

    const url = `${COMPANY_CUSTOMERS_ENDPOINT}?${QueryString.stringify(query)}`;

    const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

    await isErrorResponse(response);

    const customers = await response.json();

    dispatch({
      type: GET_COMPANY_CUSTOMERS,
      payload: customers,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingCompanyCustomers(false));
  }
};

const clearCompanyCustomers = () => (dispatch) =>
  dispatch({
    type: CLEAR_COMPANY_CUSTOMERS,
  });

const flagGettingCompanyBusiness = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_COMPANY_BUSINESSES,
    payload: flag,
  });

const getCompanyBusinesses = async (query) => async (dispatch) => {
  try {
    dispatch(flagGettingCompanyBusiness(true));

    const url = `${COMPANY_BUSINESSES_ENDPOINT}?${QueryString.stringify(
      query,
    )}`;

    const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

    await isErrorResponse(response);

    const businesses = await response.json();

    dispatch({
      type: GET_COMPANY_BUSINESSES,
      payload: businesses,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingCompanyBusiness(false));
  }
};

const clearCompanyBusinesses = () => (dispatch) =>
  dispatch({
    type: CLEAR_COMPANY_BUSINESSES,
  });

export {
  getCompanies,
  clearCompanies,
  postCompany,
  getCompany,
  clearCompany,
  putCompany,
  deleteCompany,
  getCompanyCustomers,
  clearCompanyCustomers,
  getCompanyBusinesses,
  clearCompanyBusinesses,
};
